// extracted by mini-css-extract-plugin
export default {"wrapper":"image-placeholder_wrapper__XBAxC","emptyBox":"image-placeholder_emptyBox__jtwPY"};